import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { pearlandConfig } from "./data";

export default function PearlandPage() {
  return <CityPageTemplate config={pearlandConfig} />;
}